import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
 
export default {
  layout: 'image-left',
  background: 'var(--color-primary)',
  ...cloneDeep(baseDefaults)
}
